var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 4.85C13.2637 4.19969 12.9498 3.36453 12.95 2.5H10.375V12.8333C10.3551 13.3925 10.1191 13.9222 9.71648 14.3108C9.31389 14.6994 8.77622 14.9166 8.21667 14.9167C7.03334 14.9167 6.05001 13.95 6.05001 12.75C6.05001 11.3167 7.43334 10.2417 8.85834 10.6833V8.05C5.98334 7.66667 3.46667 9.9 3.46667 12.75C3.46667 15.525 5.76668 17.5 8.20834 17.5C10.825 17.5 12.95 15.375 12.95 12.75V7.50833C13.9942 8.25821 15.2478 8.66054 16.5333 8.65833V6.08333C16.5333 6.08333 14.9667 6.15833 13.8333 4.85Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarTikTok);
export default __webpack_public_path__ + "static/media/SidebarTikTok.4abff379fda568bf0022e73d97a7b365.svg";
export { ForwardRef as ReactComponent };